import { PrimaryButton } from '@/app/components/carbon/button';

import { ArrowLeft } from 'lucide-react';
import { FC } from 'react';

interface ErrorContainerProps {
  code: string;
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
}

export const ErrorContainer: FC<ErrorContainerProps> = ({
  code,
  title,
  description,
  actionLabel,
  onAction,
}) => {
  return (
    <div className="container flex flex-col md:flex-row items-center justify-center px-5">
      <div className="max-w-md">
        <div className="text-5xl font-dark font-semibold">{code}</div>
        <p className="text-3xl md:text-3xl leading-normal mt-4">{title}</p>
        <p className="mb-8 mt-2">{description}</p>

        <PrimaryButton size="md" onClick={onAction} className="pr-4">
          <ArrowLeft className="w-5 h-5 mr-2" strokeWidth={1.5} />{' '}
          <span>{actionLabel}</span>
        </PrimaryButton>
      </div>
    </div>
  );
};
